@if (product && product.code && !product.isCustom) {
  <a tabindex="0" [routerLink]="['/p', product.code]" target="{{ urlTarget }}">
    <img [src]="getImage()" alt="" />
  </a>
} @else {
  <img [src]="getImage()" alt="" />
}
